export default __webpack_public_path__ + "static/media/herobanner.ddd6cff7.webp";